import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import UserSessionContext from 'context/UserSessionContext'

import makeStyles from '@material-ui/core/styles/makeStyles';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';

import InsertChartIcon from '@material-ui/icons/InsertChart';
import UsersIcon from '@material-ui/icons/People';
import CommentIcon from '@material-ui/icons/Comment';
import HomeIcon from '@material-ui/icons/Home';

import Profile from './components/Profile';
import SidebarNav from './components/SidebarNav';

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));

const Sidebar = props => {
  const { open, variant, onClose, className, ...rest } = props;
  const { session } = useContext(UserSessionContext);
  const { homepagePreference } = session;
  const classes = useStyles();

  const pages = [
    {
      title: 'Home',
      href: homepagePreference,
      icon: <HomeIcon />
    },
    {
      title: 'Users',
      href: '/admin/users',
      icon: <UsersIcon />
    },
    {
      title: 'Overlays',
      href: '/admin/overlays',
      icon: <InsertChartIcon />
    },
    {
      title: 'Rich Text Editor',
      href: '/admin/rich-text',
      icon: <CommentIcon />
    }
  ];

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}
    >
      <div {...rest} className={classes.root}>
        <Profile />
        <Divider className={classes.divider} />
        <SidebarNav className={classes.nav} pages={pages} />
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

Sidebar.defaultProps = {
  className: null
};

export default Sidebar;
